// ------------------------------------------------------------------------------
// name: utils
// author: mudas
// created: 2025/10/29
// ------------------------------------------------------------------------------

import { hashQueryKey, QueryKey } from '@tanstack/query-core';
import { UseQueryOptions } from '@tanstack/react-query';

export function hashQueryKeyByOptions<TQueryKey extends QueryKey = QueryKey>(
  option: UseQueryOptions<any, any, any, TQueryKey>,
): string {
  const { queryKey, queryHash, queryKeyHashFn } = option;
  const hashFn = queryKeyHashFn || hashQueryKey;
  return queryHash || hashFn(queryKey!);
}
